/**
 * API Configuration
 * Centralized configuration for API base URL
 */

export const API_BASE_URL = "https://api.profound.club";
// export const API_BASE_URL = "http://localhost:8000";
